import React, { useState } from 'react';
import './FAQ.css';

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQConfig {
  title: string;
  subtitle?: string;
  items: FAQItem[];
}

interface FAQProps {
  config?: Partial<FAQConfig>;
}

const defaultFAQConfig: FAQConfig = {
  title: "Frequently Asked Questions",
  subtitle: "Everything you need to know about our platform",
  items: [
    {
      question: "How quickly can I launch my iGaming platform?",
      answer: "You can launch your fully operational casino, sportsbook, or lottery platform in just 30 minutes. No development team or technical expertise required."
    },
    {
      question: "What payment methods are supported?",
      answer: "We support over 300 payment methods including both fiat and cryptocurrency options. Integration is done in just a few clicks."
    },
    {
      question: "Do I need a license to operate?",
      answer: "We provide licensing coverage across 185 countries and the US (for Sweepstakes). Our platform handles all licensing requirements for you."
    },
    {
      question: "What games are available?",
      answer: "We offer over 15,000 popular casino games and unlimited sports betting options at no monthly cost. All games are included in your subscription."
    },
    {
      question: "Can I customize the design after launch?",
      answer: "Yes! You have unlimited design options and can change your platform's appearance at any time, even after launch, with zero downtime."
    },
    {
      question: "What support is included?",
      answer: "We provide full coverage of day-to-day operations including 24/7 customer support, KYC/AML, anti-fraud, payment processing, CRM, and affiliate management."
    },
    {
      question: "What is the pricing structure?",
      answer: "We offer flexible pricing options starting from $4,999 setup fee. Choose between revenue-sharing models or fixed monthly subscriptions based on your needs."
    },
    {
      question: "Is there a loss coverage program?",
      answer: "Yes, we offer 100% loss coverage to protect your business during the initial growth phase."
    }
  ]
};

const FAQ: React.FC<FAQProps> = ({ config }) => {
  const mergedConfig = { ...defaultFAQConfig, ...config };
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">{mergedConfig.title}</h2>
        {mergedConfig.subtitle && (
          <p className="faq-subtitle">{mergedConfig.subtitle}</p>
        )}
        <div className="faq-list">
          {mergedConfig.items.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? 'open' : ''}`}
                onClick={() => toggleQuestion(index)}
                aria-expanded={openIndex === index}
              >
                <span>{item.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

